import {create} from 'zustand';

interface StepSettings {
  canTitleEdit: boolean;
}

interface StepSettingsStore {
  state: {
    [key: string]: StepSettings;
  };
  setCanTitleEdit: (stepId: string, canEdit: boolean) => void;
  getSettingsById: (stepId: string) => StepSettings;
}

export const useStepSettingsStore = create<StepSettingsStore>((set, get) => ({
  state: {},

  setCanTitleEdit: (stepId: string, canEdit: boolean) => {
    set((state) => ({
      state: {
        ...state.state,
        [stepId]: {
          ...state.state[stepId],
          canTitleEdit: canEdit,
        },
      },
    }));
  },

  getSettingsById: (stepId: string) => get().state?.[stepId],
}));
